<template>
  <div class="container-fluid full-width-page-wrapper ifac-officials">
    <div>
      <h3 class="font-weight-bold page-title">Awardees</h3>

      <div class="mb-4 border-0">
        <awards v-if="categories" :categories="categories"/>
      </div>
    </div>
  </div>
</template>

<script>
import OfficialsPublic from '@/services/Api/Public/Officials';

export default {
  components: {
    awards: () => import('@/views/areas/awards/partials/Awardees.vue'),
  },
  name: 'AwardsIndex',
  data() {
    return {
      categories: [],
    };
  },
  async mounted() {
    await this.fetchOfficialsCategories();
  },
  methods: {
    async fetchOfficialsCategories() {
      const { data: { data } } = await OfficialsPublic.selectors('awardees');

      this.categories = data;
    },
  },
};
</script>
